import PropTypes from 'prop-types'
import clsx from 'clsx'
import { convertSvgToBase64Uri } from 'app/utils'
import Styles from './styles.module.scss'

// This component only used for rendering svg icons as background image
function IconAsBgImage({ svg = null, url, size = '', className = '' }) {
  const customCssVariables = {
    '--raychat-icon-bg-image': svg ? convertSvgToBase64Uri(svg) : `url(${url})`,
    '--raychat-icon-bg-image-size': size,
  }

  return <span className={clsx(Styles.icon, 'icon_wrapper', className)} style={customCssVariables} />
}

IconAsBgImage.propTypes = {
  svg: PropTypes.element,
  className: PropTypes.string,
  size: PropTypes.string,
}

export default IconAsBgImage
